import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"

import { TYPE } from "../../../../theme/styles/globals"

export const PRE = styled.p`
  display:inline;
  color:${props => props.color || "black"};
  font-size:12px;
  font-family:${TYPE.MONO_FONT}, sans-serif;
  text-transform:uppercase;
  letter-spacing:4px;
`
